// eslint-disable-next-line no-shadow

export enum EPerfil {
  SOCIO = 'SOCIO',
  RESPONSAVEL = 'RESPONSAVEL',
}
